import "../../assets/scss/main.scss";

import { useTournamentStateContext } from "../../data/providers/TournamentStateProvider";
import { CheckInRoundOption, Round } from "../../types";
import { CloseModalIcon } from "../CloseModalIcon";

interface RoundModalProps {
  selectRound: (roundOption: CheckInRoundOption) => void;
  cancel: () => void;
  selectedRound: number;
}

export const RoundModal = ({
  selectRound,
  cancel,
  selectedRound,
}: RoundModalProps) => {
  const { roundsState } = useTournamentStateContext();

  return (
    <div className="checkInRoundModalContent">
      <CloseModalIcon onRequestClose={cancel} />
      <div className="chipContainer">
        <button
          className={selectedRound === 0 ? "chip chipSelected" : "chip"}
          onClick={() =>
            selectRound({
              id: 0,
              name: "All Rounds",
            })
          }
        >
          All Rounds
        </button>
        {roundsState.map((r: Round) => {
          return (
            <button
              key={r.id}
              className={selectedRound === r.id ? "chip chipSelected" : "chip"}
              onClick={() =>
                selectRound({
                  id: r.id,
                  name: r.name,
                })
              }
            >
              {r.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};
